//these are common person titles used in the lexicon and sentence segmentation methods
//they are also used to identify that a noun is a person
  var main = [
    //honourifics
    "jr",
    "mr",
    "mrs",
    "ms",
    "dr",
    "prof",
    "sr",
    "sen",
    "corp",
    "rep",
    "gov",
    "atty",
    "supt",
    "det",
    "rev",
    "col",
    "gen",
    "lt",
    "cmdr",
    "adm",
    "capt",
    "sgt",
    "cpl",
    "maj",
    "miss",
    "misses",
    "mister",
    "sir",
    "esq",
    "mstr",
    "phd",
    "adj",
    "adv",
    "asst",
    "bldg",
    "brig",
    "comdr",
    "hon",
    "messrs",
    "mlle",
    "mme",
    "op",
    "ord",
    "pvt",
    "reps",
    "res",
    "sens",
    "sfc",
    "surg",
  ]

module.exports = main;



//////////////////
// WEBPACK FOOTER
// ./~/nlp_compromise/src/data/lexicon/honourifics.js
// module id = 43
// module chunks = 0